import React from "react";

export class WeightBold extends React.Component<React.PropsWithChildren<{}>> {
    public render (): JSX.Element {
        return (
            <span className="weight-bold">{this.props.children}</span>
        );
    }
}
